<h1>SEMINARI</h1>
<p> Tra le attività della De Cifris troviamo l'istituzione di seminari
	a tema crittografico. I cicli di carattere tematico verranno riattivati in futuro.
</p>
<h2>De Cifris Agora</h2>
<p>
	<a [routerLink]="['/attivita/decifris-agora']">De Cifris Agora</a>: annunci di seminari proposti dai
	nostri soci a tutta la comunità De Cifris. <br> Le tematiche sono ampie ed a discrezione del proponente.
</p>
<h2>Seminari tematici</h2>
<p>
	(non attivi al momento)
</p>
<ul>
	<li><a routerLink="/attivita/eruditorum">De Cifris Eruditorum</a>: annunci di
		seminari sull'interazione della crittografia con la Società,
		trattando la politica, il diritto e l’impatto culturale.</li>
	<li><a routerLink="/attivita/decifris-athesis">De Cifris Athesis</a>: annunci sui seminari che
		teniamo a Trento, circa uno al mese.</li>
	<li><a routerLink="/attivita/decifris-augustaetaurinorum">De Cifris Augustae Taurinorum</a>: annunci
		sui seminari che teniamo a Torino, circa uno al mese.</li>
	<li><a routerLink="/attivita/deCifris-scholalatina">De Cifris Schola Latina</a>: annunci sui seminari
		che teniamo a Roma, circa uno al mese.</li>
	<li><a routerLink="/attivita/decifris-mediolanensibus">De Cifris Mediolanensibus</a>: annunci sui
		seminari che teniamo a Milano, circa uno al mese.</li>
	<li><a routerLink="/attivita/cifrischain" fragment="seminari">Cifris Chain</a>:
		seminari incentrati sugli aspetti crittografici della tecnologia blockchain e
		del concetto di cryptocurrency.</li>
	<li><a routerLink="/attivita/quantumcifris" fragment="seminari">QuantumCifris</a>:
		annunci di eventi e progetti specifici per QuantumCifris (il nostro
		team interno che lavora su Quantum Cryptography)</li>
	<li><a routerLink="/attivita/pqcifris" fragment="seminari">PQCifris</a>: seminari
		incentrati sulla crittografia Post-Quantum.</li>
	<li><a routerLink="/attivita/cifriscloud" fragment="seminari">CifrisCloud</a>:
		annunci su seminari riguardo le interazioni tra la crittografia e il cloud computing.</li>
	<li><a routerLink="/attivita/mathcifris" fragment="seminari">Math Cifris</a>: annunci sui seminari
		incentrati sugli aspetti più matematici della crittografia.</li>
	<li><a routerLink="/attivita/decifris-historiae" fragment="seminari">De Cifris Historiae</a>:
		annunci di seminari riguardanti la Storia della Crittografia.</li>
</ul>
<hr>
<!-- <div class="row">
				<div class="col-md-12">
					<h3>PROSSIMI SEMINARI</h3>
					<ul>
						
					</ul>
				</div>
			</div>
			<hr> -->
<h3>SEMINARI RECENTI</h3>
<ul>
	<li>
		<b> 13 Dicembre 2022 - 15:00</b>
		<ul>
			<li>
				<b>Emanuele Giunta</b> -- IMDEA Software Institute, Universidad Politécnica de
				Madrid <br>
				<i>"On the Impossibility of Algebraic Vector Commitments in Pairing-Free
					Groups"</i><br>
				<a href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/12.2022 Giunta.pdf">Locandina</a>
			</li>
		</ul>
	</li>
	<li>
		<b>1 Dicembre - 11:30</b>
		<ul>
			<li>
				<b>Alessio Meneghetti</b> -- Università di Trento <br>
				<i>"On a link between Code-Based and Multivariate-Based Cryptosystems"</i><br>
				<a href="../../../assets/attivita/gruppi/PQCifris/
									12.2022-Meneghetti_Tognolini.pdf">Locandina</a>
			</li>
			<li>
				<b>Giovanni Tognolini</b> -- Università di Trento <br>
				<i>"Towards a Post Quantum OTS Scheme using QC-LDPC Codes"</i><br>
				<a href="../../../assets/attivita/gruppi/PQCifris/
									12.2022-Meneghetti_Tognolini.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/PQCifris/tognolini_slide.pdf">Slide</a>
			</li>
		</ul>
	</li>
	<li>
		<b>23 Novembre - 16:00</b>
		<ul>
			<li>
				<b>Paolo Bonavoglia</b> <br>
				<i>"Franceschini VS Partenio. Una disputa crittografica nella Venezia del
					Cinquecento"</i><br>
				<a
					href="../../../assets/attivita/seminariLocali/deCifrisScholaLatina/11.2022-Bonavoglia.pdf">Locandina</a>
				--
				<a
					href="../../../assets/attivita/seminariLocali/deCifrisEruditorum/11.2022-SLIDE_Bonavoglia.pdf">Slide</a>
			</li>
		</ul>
	</li>
	<li>
		<b>2 Novembre - 10:00</b>
		<ul>
			<li>
				<b>Luca Mariot</b> -- Radboud University <br>
				<i>"Behind the scenes of a new construction for bent functions:
					a tour among cellular automata, Latin squares and linear
					recurring sequences"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/
									MARIOT.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/
									Mariot_talk_2022.pdf">Slide</a> --
				<a href="https://mega.nz/file/A1lnkLIC#zr8FCRmq1zVLg
									8NXex3tiC0_iruKJWY7UU8fjJYU9rY">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b>10-11-12 Ottobre</b>
		<ul>
			<li>
				<a href="/attivita/pqcifris-summer22">PQCifris 2022</a> -- University of Trento <br>
				<i>"Workshop on Post-Quantum Cryptography"</i><br>
				<a href="../../../assets/attivita/PQCifris2022/Locandina
									PQCifris.pdf">Locandina</a>
			</li>
		</ul>
	</li>
	<li>
		<b>20 Settembre 2022 - 14:30</b>
		<ul>
			<li>
				<b>Veronica Cristiano</b> -- Telsy SpA <br>
				<i>"Cryptographic aspects in WireGuard, a modern VPN protocol"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifrisAugu
									staeTaurinorum/veronicaCristiano.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifrisAugu
									staeTaurinorum/Allegato 1 - Cristiano.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=1nw6TOdYYxA">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b>9 Giugno 2022 - 16:00</b>
		<ul>
			<li>
				<b>Edoardo Persichetti</b> -- Florida Atlantic University <br>
				<i>"Developing Innovative Frameworks for Efficient Code-based Signatures"</i><br>
				<a href="../../../assets/attivita/gruppi/PQCifris/06.2022-Persichetti (1).pdf">Locandina</a>
				--
				<a href="../../../assets/attivita/gruppi/PQCifris/Persichetti_9 giugno.pdf">Slide</a>
				--
				<a href="https://www.youtube.com/watch?v=RSIuTnuVpiA">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b>7 Giugno 2022 - 14:00</b>
		<ul>
			<li>
				<b>Andrea Mari</b> -- Unitary Fund <br>
				<i>"Quantum computers in theory and in practice"</i><br>
				<a href="../../../assets/attivita/gruppi/PQCifris/05.2022-
									Mari.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/PQCifris/Allegato1_
									Slide_Mari.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=61bX0j8ov5s">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b>31 Maggio 2022 - 17:00</b>
		<ul>
			<li>
				<b>Daniele Ballo</b> -- Eustema <br>
				<i>"Key management systems vs homorphic encryption"</i><br>
				<a href="../../../assets/attivita/gruppi/cifrisCloud/31.05.
									2022-Ballo.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/cifrisCloud/Ballo_
									31_Maggio.pdf">Slide</a> --
				<a href="https://mega.nz/file/rAlSgK4Y#jilX0d18Y8-
									r692I-tAFFn7UTB3F0qWcY7tqF87FIg8">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b> 31 Maggio 2022 - 14:30</b>
		<ul>
			<li>
				<b>Annamaria Iezzi</b> -- Università di Napoli <br>
				<i>"Computing the endomorphism ring of a supersingular elliptic curve"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifris
									ScholaLatina/ALLEGATO 4_Iezzi-ScholaLatina.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifrisScholaLatina/Iezzi_31_maggio.pdf">Slide</a>
			</li>
		</ul>
	</li>
	<li>
		<b> 24 Maggio 2022 - 15:30</b>
		<ul>
			<li>
				<b>Michela Ceria</b> -- Politecnico di Bari <br>
				<i>"A Blockchain Hour: Monero's World"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifris
									Mediolanensibus/Allegato 3_Ceria_Mediolanesibus.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifris
									Mediolanensibus/Ceria_24_maggio.pdf">Slide</a>
			</li>
		</ul>
	</li>
	<li>
		<b> 17 Maggio 2022 - 16:00</b>
		<ul>
			<li>
				<b>Gessica Alecci</b> -- Politecnico di Torino <br>
				<i>"A study on the use of PellHyperbolas in DLP-based crypto systems"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifris
									AugustaeTaurinorum/Allegato 1_Alecci_Taurinorum.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifrisAugustae
									Taurinorum/Alellegato2_ Alecci.pdf">Slide</a>
			</li>
		</ul>
	</li>
	<li>
		<b> 10 Maggio 2022 - 16:00</b>
		<ul>
			<li>
				<b>Marco Martinoli</b> -- Proton AG <br>
				<i>"Cryptography vs Real World"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifrisAthesis/
									05.2022 Martinoli.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifris
									Athesis/Allegato1_Martinoli.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=3lYc-lkhRhY">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b> 4 Maggio 2022 - 16:00</b>
		<ul>
			<li>
				<b>Giovanni Zini</b> -- Università degli Studi di Modena e Reggio Emilia <br>
				<i>"Funzioni Generalized APN in caratteristica dispari e curve algebriche"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/Allegato4_
									MathCifris_Locandina_05.2022-Giovanni-Zini.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/Allegato2_
									Zini_MathCifris.pdf">Slide</a>
			</li>
		</ul>
	</li>
	<li>
		<b> 13 Aprile 2022</b> -- ore 15:00
		<ul>
			<li>
				<b>Marco Cesati</b> -- Università di Roma Tor Vergata<br>
				<i>"A new idea for RSA backdoors"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifris
									ScholaLatina/Cesati-ScholaLatina-13.04.2022.docx-3.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifris
									ScholaLatina/Allegato2_ScholaLatina_SLIDE_Cesati_1304.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=-KHZn0ttO5w">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b> 12 Aprile 2022</b>
		<ul>
			<li>
				<b>Lorenzo Zaccagnini</b> -- Devoleum<br>
				<i>"Vulnerabilità note di Solidity"</i><br>
				<a href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/
									04.2022 Zaccagnini.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifris
									Athesis/Allegato1_Athesis_Zaccagnini.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=4lnw7_uVhTA">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b>6 Aprile 2022 - 16:00</b>
		<ul>
			<li>
				<b>Marzio Mula</b> -- Università di Trento <br>
				<i>"Random sampling of supersingular elliptic curves"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/04.2022-
									Marzio-Mula.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/Allegato 1
									_SLIDE_MathCifrisMula_6Aprile.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=5ckEjOSA1uI">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>5 Aprile 2022 - 15:00</b>
		<ul>
			<li>
				<b>Shi Bai</b> -- Florida Atlantic University <br>
				<i>"Lattice algorithms for variants of LWE"</i><br>
				<a href="../../../assets/attivita/gruppi/PQCifris/04.2022-Shi
									Bai.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/PQCifris/Allegato2_
									PQCifris_ShiBai.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=lqsptSSR-wQ">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>2 Marzo 2022 - 16:00</b>
		<ul>
			<li>
				<b>Martino Borello</b> -- Université Paris 8-LAGA. <br>
				<i>"Il principio di indeterminazione dal punto di vista della
					teoria dei codici"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/03.2022-
									Martino-Borello.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/Presentazi
									one_Borello.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=0DOkTuBeSYU">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b> 15 Febbraio 2022</b>
		<ul>
			<li>
				<b>Luca De Feo</b> -- IBM Zurigo <br>
				<i>"Crittografia a Base di Isogenie"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifris
									ScholaLatina/DeFeo15Febbraio.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifrisSchola
									Latina/ALLEGATO 1-DE FEO-2022-02-15-rome.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=dOKY7pgjNxw">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b> 15 Marzo 2022</b>
		<ul>
			<li>
				<b>Chiara Marcolla</b> -- Technology Innovation Institute (AE) <br>
				<i>"Searchable Encryption and a practical construction"</i> <br>
				<a href="../../../assets/attivita/seminariLocali/deCifris
									AugustaeTaurinorum/MarcollaLocandina.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifrisAugu
									staeTaurinorum/MarcollaSlide.pdf">Slide</a>
			</li>
		</ul>
	</li>
	<li>
		<b> 8 Febbraio 2022</b>
		<ul>
			<li>
				<b>Michele Orrù</b> -- UC Berkeley (US)<br>
				<i>"Breaking 20 years of Schnorr-like blind signatures"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifris
									Athesis/OrruLocandina.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifris
									Athesis/orru-athesis.pdf">Slide</a>
			</li>
		</ul>
	</li>
	<li>
		<b>2 Febbraio 2022</b>
		<ul>
			<li>
				<b>Irene Villa</b> -- Università degli Studi di Trento <br>
				<i>"The classification of planar monomials over fields of order
					a prime cubed"</i> <br>
				<a href="../../../assets/attivita/gruppi/mathCifris/Irene
									VillaLocandina.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/IreneVilla
									Slide.pdf">Slide</a>
			</li>
		</ul>
	</li>
	<li>
		<b> 1 Febbraio 2022</b>
		<ul>
			<li>
				<b>Edoardo Persichetti</b> -- Florida Atlantic University (US) <br>
				<i>"Code-based Signatures: New Approaches and Research Directions"</i> <br>
				<a href="../../../assets/attivita/gruppi/PQCifris/Persichetti
									Locandina.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/PQCifris/Persichetti
									Slide.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=5mTf4XNNRrQ">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b> 25 Gennaio 2022</b>
		<ul>
			<li>
				<b>Antonino Alì</b> -- Università di Trento,
				<b>Andrea Monti</b> -- Università di Chieti-Pescara <br>
				<i>"Chi ha paura della crittografia?"</i><br>
				<a href="../../../../assets/attivita/seminariLocali/deCifris
									Eruditorum/Monti.Ali.docx.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifris
									Eruditorum/AntoninoSlide.key.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=ENJFHPBWWfQ">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b> 19 Gennaio 2022 -- 15:00 </b>
		<ul>
			<li>
				<b>Fadi Barbara</b> -- Università di Torino <br>
				<i>"Digital signature for interoperability and privacy in
					blockchains"</i><br>
				<a href=".././../../assets/attivita/gruppi/cifrisChain/
									FadiBarbara.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/cifrisChain/Allegato1_
									CifrisChain_SLIDE_Barbara.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=6RU7xDmz7Ok">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b> 18 Gennaio 2022</b>
		<ul>
			<li>
				<b>Javier Verbel</b> -- Technology Innovation Institute (AE) <br>
				<i>"Practical complexities of probabilistic algorithms
					for solving Boolean polynomial systems"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifris
									AugustaeTaurinorum/01.2022-Javier Verbel.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifris
									AugustaeTaurinorum/ALLEGATO1_Slide_Verbel.pdf">Slide</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b> 12 Gennaio 2022</b>
		<ul>
			<li>
				<b>Giada Sciarretta</b> -- Fondazione Bruno Kessler, Trento<br>
				<i>"Applications based on CIE 3.0: from the design to the
					security assessment"</i><br>
				<a href=".././../../assets/attivita/seminariLocali/deCifris
									Athesis/SCIARRETTA.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifris
									Athesis/SciarrettaSlide.pdf">Slide</a> --
				<a href="https://mega.nz/file/qc1QwARa#DtfKxWqDj_6ka5KP8DJrzm
									cipx3by1IrWI80wHhjVKg">Video</a>
				<br>
			</li>
		</ul>
	</li>

</ul>
<hr>
<h3>SEMINARI PASSATI</h3>
<ul>
	<li>
		<b>7 Dicembre 2021</b>
		<ul>
			<li>
				<b>Cecilia Boschini</b> -- Technion‌<br>
				<i>"How to do Efficient Signature Verification without Leakage"</i><br>
				<a href=".././../../assets/attivita/gruppi/PQCifris/12.2021_Boschini.pdf">Locandina</a>
				--
				<a href=".././../../assets/attivita/gruppi/PQCifris/Boschini.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=L1USfpbSvgo">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>1 Dicembre 2021</b>
		<ul>
			<li>
				<b>Daniele Bartoli</b> -- Università degli Studi di Perugia <br>
				<i>"Teoremi di tipo Hasse-Weil e classi rilevanti di funzioni
					polinomiali"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/Bartoli_Locandina.pdf">Locandina</a>
				--
				<a href="../../../assets/attivita/gruppi/mathCifris/BartoliSlide.pdf">Slide</a>
				<br>
			</li>
			<li>
				<b>Andrea Gangemi e Alessandro Guggino</b> -- Politecnico di Torino <br>
				<i>"Schnorr and Taproot: an overview of the new Bitcoin update"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifrisAugust
									aeTaurinorum/12.2021-Gangemi-Guggino.pdf">Locandina</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>30 Novembre 2021 -- 14:30</b>
		<ul>
			<li>
				<b>Federico Pintore</b> -- Università di Bari <br>
				<i>"Collision on isogeny graphs and the security of the
					SIDH-based identification protocol"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifrisSchola
									Latina/Pintore_Locandina_11.2021.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifris
									ScholaLatina/Allegato3_ScholaLatina_SLIDE_Pintore - Tor 
									Vergata 31-11-2021.pdf">Slide</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>9 Novembre 2021</b> -- 15:00
		<ul>
			<li>
				<b>Valentina De Cian</b> -- TriNANDable‌ <br>
				<i>"LDPC‌ ‌codes‌ ‌for‌ ‌storage‌ ‌applications‌"</i><br>
				<a href="../../../assets/attivita/seminariLocali/
									deCifrisAthesis/11.2021_DeCian.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifris
									Athesis/DeCian-slide.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=RWlynaR4kWw">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>3 Novembre 2021 -- 16:30</b>
		<ul>
			<li>
				<b>Ilaria Zappatore</b> -- INRIA Paris <br>
				<i>"Una tecnica per costruire algoritmi resistenti agli errori
					per la risoluzione di sistemi lineari polinomiali"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/
										11.2021_Ilaria_Zappatore.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/Zappatore_
									Slide.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=J7czOyTdIyc">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>2 Novembre 2021</b>
		<ul>
			<li>
				<b>Paolo Santini</b> -- Università‌ ‌Politecnica‌ ‌delle‌ ‌Marche<br>
				<i>" Recent advances in code-based encryption and digital signatures"</i><br>
				<a href="../../../assets/attivita/gruppi/PQCifris/11.2021_Santini.pdf">Locandina</a>
				--
				<a href="../../../assets/attivita/gruppi/PQCifris/11.2021-SantiniSlide.pdf">Slide</a>
				--
				<a href="https://www.youtube.com/watch?v=KBTKdT4IP84&t=6s">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>12 Ottobre 2021</b> -- 15:00
		<ul>
			<li>
				<b>Enrico Zimuel</b> -- Principal Software Engineer, Elastic <br>
				<i>"Introduzione alle problematiche nell'implementazione dei sistemi
					crittografici"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifrisMediolanensibus/EnricoZimuel.pdf">Locandina</a>
				--
				<a href="../../../assets/attivita/seminariLocali/deCifrisMediolanensibus/Zimuel12102021.pdf">Slide</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>5 Ottobre 2021</b> -- 15:00
		<ul>
			<li>
				<b>Luca Nizzardo</b> -- Protocol Labs <br>
				<i>"Filecoin: From Proof of Space to Decentralised Storage"</i><br>
				<a href="../../../assets/attivita/gruppi/cifrisChain/LucaNizzardoLocandina.pdf">Locandina</a>
				--
				<a href="../../../assets/attivita/gruppi/cifrisChain/Filecoin_Luca_CifrisChain 2021Slide.pdf">Slide</a>
				--
				<a href="https://mega.nz/file/rJcTgC4a#nn79u9pbp4WRq7xiG0-AGjjCHw17qvWbR9KJEvdj5C8">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>7 Luglio 2021 - 16:00</b>
		<ul>
			<li>
				<b>Roberto La Scala</b> -- Università degli Studi di Bari Aldo Moro. <br>
				<i>"Cifrari ed Equazioni alle Differenze"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/LaScalaLocandina.pdf">Locandina</a>
				--
				<a href="../../../assets/attivita/gruppi/mathCifris/LaScalaSlide.pdf">Slide</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>19 Giugno 2021 - 14:30</b>
		<ul>
			<li>
				<b>Guglielmo Morgari</b> -- Telsy. <br>
				<i>"IOTA and the TANGLE"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifris
									AugustaeTaurinorum/MorgariLocandina.pdf">Locandina</a> --
				<a href="https://www.youtube.com/watch?v=TcqHqtTB-fY">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>18 Giugno 2021 - 11:00</b>
		<ul>
			<li>
				<b>Roberto Civino</b> -- University of L’Aquila. <br>
				<i>"On invariant subspaces in the Lai-Massey scheme
					and a primitivity reduction"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifrisSchola
									Latina/RobertoCivino-ScholaLatina.pdf">Locandina</a> --
				<a href="../../../../assets/attivita/seminariLocali/deCifrisSch
									olaLatina/Civino_Sinopsi.pdf">Sinopsi</a> --
				<a href="https://www.youtube.com/watch?v=TcqHqtTB-fY">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>9 Giugno 2021 - 16:00</b>
		<ul>
			<li>
				<b>Alberto Ravagnani</b> -- Eindhoven University of Technology. <br>
				<i>"Il Codice Tipico su un Grande Alfabeto"</i><br>
				<a href="../../../assets/attivita/gruppi/mathCifris/Ravagnani.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/RavagnaniSlides.pdf">Slide</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>7 Giugno 2021 - 10:00</b>
		<ul>
			<li>
				<b>Marco Calderini</b> -- University of Bergen <br>
				<i>"Permutation groups and security of block ciphers"</i><br>
				<a
					href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/CalderiniLocandina.pdf">Locandina</a>
				--
				<a href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/calderiniSlide.pdf">Slide</a>
				--
				<a href="https://youtu.be/Zd2AqqA2UVM">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>26 Maggio 2021 - 17:00</b>
		<ul>
			<li>
				<b>Marco Gaboardi</b> -- Boston University.<br>
				<i>"Differential privacy"</i><br>
				<a href="../../../assets/attivita/gruppi/cifrisCloud/Gaboardi.pdf">Locandina</a> --
				<a href="https://mega.nz/file/Tw5QBABR#X-OVHfxpZbWo-EWmGy-C7kzX1hJGmCIYzbKoJZUVz5s">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>20 Maggio 2021 - 10:00</b>
		<ul>
			<li>
				<b>Annamaria Iezzi</b> -- Université de la Polynésie Française. <br>
				<i>"Strumenti per fare crittoanalisi nei grafi di isogenie supersingolari"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifrisAthesis/Iezzi.pdf">Locandina</a>
				--
				<a href="../../../assets/attivita/seminariLocali/deCifrisAthesis/IezziIsogeny.pdf">Slide</a>
				--
				<a href="https://youtu.be/b9YU-UNgVSs">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>17 Maggio 2021 - 15:30</b>
		<ul>
			<li>
				<b>Gianira Alfarano </b> -- University of Zurich <br>
				<i>"A geometric interpretation of minimal codes"</i> <br>
				<a href="../../../assets/attivita/seminariLocali/deCifrisScholaLatina/Gianira.pdf">Locandina</a>
				--
				<a href="../../../assets/attivita/seminariLocali/deCifrisScholaLatina/Gianira2.pdf">Slide</a>
				--
				<a href="https://mega.nz/file/KOQ2kDrA#Yvug6FTe1eGA2b9bpam5p8MVzKbavNFePPy7i6m1WXE">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b>5 Maggio 2021 - 15:00</b>
		<ul>
			<li>
				<b>Luca de Feo</b> -- Université de Versailles – Saint-Quentin e IBM Zurich <br>
				<i>"La corrispondenza di Deuring effettiva – la chiave per la prossima
					generazione di crittografia basata sulle isogenie?"</i> <br>
				<a href="../../../assets/attivita/gruppi/mathCifris/DeFeo.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/DeFeoSlide.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=Ktp1VVuuM9U">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b>26 Aprile 2021 - 12:00</b>
		<ul>
			<li>
				<b>Riccardo Longo</b> -- Università degli Studi di Trento <br>
				<i>"Ledger Pubblico per Dati Sensibili"</i>.<br>
				<a href="../../../assets/attivita/seminariLocali/deCifrisAthesis/Longo.pdf">Locandina</a>
				--
				<a href="../../../assets/attivita/seminariLocali/deCifrisAthesis/LongoDCA.pdf">Slide</a>
				--
				<a href="https://youtu.be/649l2aKU1jY">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>28 Aprile 2021 - 17:00</b>
		<ul>
			<li>
				<b>Marcello Paris</b> <br>
				<i>"Attribute-based encryption and signatures"</i><br>
				<a href="../../../assets/attivita/gruppi/cifrisCloud/Paris.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/cifrisCloud/ParisSlide.pdf">Slide</a>
				<br>
			</li>
		</ul>
	</li>
</ul>